import React from "react";
import { Navigate } from "react-router-dom";
import { useRoles } from "../security/RolesProvider/RolesProvider";
import { PremissionsProvider } from "../security/PremissionsProvider/PremissionsProvider";
import {
  getModulePremissions,
  isModuleAccess,
} from "../security/isModuleAccess";
import { useAuth } from "../contexts/AuthProvider";

interface IAuthorizedRouteProps {
  moduleIds: string[];
  allowFullAccess?: boolean;
  children: React.ReactNode;
}

export const AuthorizedRoute: React.FC<IAuthorizedRouteProps> = (props) => {
  const { moduleIds, allowFullAccess } = props;
  const {
    userInfo: { security },
  } = useAuth();

  if (isModuleAccess(moduleIds, security, allowFullAccess)) {
    const premissions = getModulePremissions(
      moduleIds,
      security,
      allowFullAccess,
    );

    return (
      <PremissionsProvider premissions={premissions}>
        {props.children}
      </PremissionsProvider>
    );
  }

  return <Navigate to="/access" />;
};
